/**
 * @template T
 * @typedef {{statusCode: number;data: T; succeeded: boolean;errors?: any;timestamp: number; extras?:{message:string;apiStatusCode:number}}} ApiResponse
 */

//封装的axios
import request from "@/http/config/httpconfig";

export const login = (data) => {
  return request({
    url: "/UserLoginReg/UserLogin",
    method: "post",
    params: data,
  });
};

export const LoginOut = () => {
  return request({
    url: "/UserLoginReg/LoginOut",
    method: "post",
  });
};
export const LoginOutForbBit = (data) => {
  return request({
    url: "/UserLoginReg/LoginOutForbBit",
    method: "post",
    params: data
  });
};

export const BindOrg = () => {
  return request({
    url: "/UserLoginReg/BindOrg",
    method: "post",
  });
};

export const UploadFile = (data) => {
  return request({
    url: "/WebControl/UploadFile",
    method: "post",
    data,
  });
};
// 上传需下载文件
export const UploadFileBucket = (data) => {
  return request({
    url: "/WebControl/UploadFileBucket",
    method: "post",
    data,
  });
};

export const UploadFileBack = (data, back) => {
  return request({
    url: "/WebControl/UploadFile",
    method: "post",
    onUploadProgress: back,
    data,
  });
};

export const UploadAchievement = (data, back) => {
  return request({
    url: "/WebControl/UploadAchievement",
    method: "post",
    onUploadProgress: back,
    data,
  });
};

export const GetRedirectUrl = (data) => {
  return request({
    url: "/UserCenter/GetRedirectUrl",
    method: "get",
    params: data,
  });
};

//----------------收藏-----------------
// 添加收藏
// articleId
export const AddCollect = (data) => {
  return request({
    url: "/UserCenter/AddCollect",
    method: "post",
    params: data,
  });
};
// 取消收藏
// articleId
export const UpdateCollect = (data) => {
  return request({
    url: "/UserCenter/UpdateCollect",
    method: "post",
    params: data,
  });
};
// 是否收藏
// articleId userid
export const IsCollect = (data) => {
  return request({
    url: "/UserCenter/IsCollect",
    method: "post",
    params: data,
  });
};
// ----------------关注---------------------
// 是否关注 myUserid，attUserId
export const IsAttention = (data) => {
  return request({
    url: "/UserCenter/IsAttention",
    method: "post",
    params: data,
  });
};
// 添加关注 attUserId
export const AddAttention = (data) => {
  return request({
    url: "/UserCenter/AddAttention",
    method: "post",
    params: data,
  });
};
// 取消关注 attUserId
export const UpdateAttention = (data) => {
  return request({
    url: "/UserCenter/UpdateAttention",
    method: "post",
    params: data,
  });
};

// 查看个人首页
// userId
export const UserIndex = (data) => {
  return request({
    url: "/UserCenter/UserIndex",
    method: "post",
    params: data,
  });
};

/**
 * 初始化分段上传
 * @param {string} fileName 文件名
 * @returns {Promise<ApiResponse<{uploadId:string,objectName:string}>>} UploadId:分段上传ID，objectName:文件名
 */
export const InitiateMultipartUpload = (fileName) => {
  return request.post("/WebControl/InitiateMultipartUpload", null, {
    params: {
      fileName,
    },
  });
};

/**
 * 分段上传
 * @param {{file:Blob,UploadId:string,objectName:string,PartNumber:number,filePosition:number,partSize:number}} form 上传form参数
 * @param {Blob} form.file 文件
 * @param {string} form.UploadId 分段上传ID
 * @param {string} form.objectName 文件名
 * @param {number} form.PartNumber 分段上传序号
 * @param {number} form.filePosition 文件位置
 * @param {number} form.partSize 分段大小
 * @returns {Promise<ApiResponse<number>>} PartNumber,失败为0
 */
export const UploadParts = ({ file, UploadId, objectName, PartNumber, filePosition, partSize }) => {
  const form = new FormData();
  form.append("file", file);
  form.append("UploadId", UploadId);
  form.append("objectName", objectName);
  form.append("PartNumber", PartNumber);
  form.append("filePosition", filePosition);
  form.append("partSize", partSize);
  return request.post("/WebControl/UploadParts", form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * 完成分段上传
 * @param {string} UploadId 分段上传ID
 * @param {string} objectName 文件名
 *
 * @returns {Promise<ApiResponse<{path:string,downloadPath:string}>>} objectName 失败为null
 */
export const CompleteMultipartUpload = (UploadId, objectName) => {
  return request.post("/WebControl/CompleteMultipartUpload", null, {
    params: {
      UploadId,
      objectName,
    },
  });
};

/**
 * 取消分段上传
 * @param {string} UploadId 分段上传ID
 * @param {string} objectName 文件名
 *
 * @returns {Promise<ApiResponse<null>>} null
 */
export const CancleMultipartUpload = (UploadId, objectName) => {
  return request.post("/WebControl/CancleMultipartUpload", null, {
    params: {
      UploadId,
      objectName,
    },
  });
}
